import * as Actions from '../actions/vouchers.actions';

const initialState = {
  paginatedVouchers: {
    items: [],
    total: 0,
    totalPages: 0,
  },
};

const handle = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SET_VOUCHERS_LIST:
      return {
        ...state,
        paginatedVouchers: {
          ...action.paginatedVouchers,
          totalPages: Math.ceil(action.paginatedVouchers.totalCount / 20),
        },
      };
    default:
      return state;
  }
};

export default handle;
